import { ListItemButton, ListItemText, ListItemIcon } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function LegislationListItem({ item }) {
    return (
        <ListItemButton disableGutters onClick={openLink}>
            <ListItemText primary={item.title || item.ref} primaryTypographyProps={{ variant: "body2" }} />
            <ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
                <Iconify icon="mdi:open-in-new" sx={{ fontSize: 16, color: "text.secondary" }} />
            </ListItemIcon>
        </ListItemButton>
    )

    function openLink() {
        window.open(item.url, "_blank", "noopener,noreferrer")
    }
}
